<template>
  <div class="media-gallery-carousel">
    <thumbnails
      v-if="gallery && gallery.length > 1"
      :gallery="gallery"
      :product-name="productName"
      @navigateTo="navigate"
    />
    <div
      v-if="!gallery || gallery.length < 2"
      style="flex: 0 0 90px;margin: 0 20px 0 0;"
    ></div>

    <div class="carousel-wrapper">
      <carousel
        :per-page="1"
        :mouse-drag="false"
        :navigation-enabled="true"
        pagination-active-color="#828282"
        pagination-color="transparent"
        navigation-next-label="<i class='material-icons p15 cl-bg-tertiary pointer'>keyboard_arrow_right</i>"
        navigation-prev-label="<i class='material-icons p15 cl-bg-tertiary pointer'>keyboard_arrow_left</i>"
        ref="carousel"
        :speed="carouselTransitionSpeed"
        @pageChange="pageChange"
        :navigate-to="currentPage"
        v-if="this.$attrs.propOffice === config.rootcategories.drukowanie"
      >
        <slide
          v-for="(images, index) in gallery"
          :key="images.src"
        >
          <div
            class="product-image-container bg-cl-transparent"
            :class="{'video-container w-100 h-100 flex relative': images.video}"
          >
            <product-image-cloudfront
              v-show="hideImageAtIndex !== index"
              class="product-image pointer"
              :class="{ 'product-image--video': images.video }"
              :thumbnail-path="images.thumbnail_path"
              :thumbnail-size="'410'"
              :alt="productName | htmlDecode"
              @dblclick="openOverlay"
            />
            <product-video
              v-if="images.video && (index === currentPage)"
              v-bind="images.video"
              :index="index"
              @video-started="onVideoStarted"
            />
          </div>
        </slide>
      </carousel>

      <carousel
        :per-page="1"
        :mouse-drag="false"
        :navigation-enabled="true"
        pagination-active-color="#828282"
        pagination-color="transparent"
        navigation-next-label="
        <svg xmlns='http://www.w3.org/2000/svg' width='23' height='23' transform= 'rotate(90)'>
          <path
            fill-rule='evenodd'
            fill='#A4B1C2'
            d='M19.633 19.632A11.425 11.425 0 0111.5 23c-3.072 0-5.96-1.196-8.132-3.368A11.423 11.423 0 010 11.5c0-3.073 1.196-5.961 3.368-8.132A11.425 11.425 0 0111.5 0C17.841 0 23 5.159 23 11.5c0 3.072-1.196 5.961-3.367 8.132zM11.5 2.165c-5.147 0-9.335 4.187-9.335 9.335 0 5.147 4.188 9.335 9.335 9.335 5.148 0 9.335-4.188 9.335-9.335 0-5.148-4.187-9.335-9.335-9.335zm4.229 8.673a1.11 1.11 0 01-.814.366 1.07 1.07 0 01-.699-.261l-1.633-1.397v6.311c0 .607-.476 1.083-1.083 1.083a1.071 1.071 0 01-1.082-1.083V9.546l-1.631 1.395a1.044 1.044 0 01-.705.272 1.07 1.07 0 01-1.069-1.098c0-.338.125-.624.363-.828L11.5 5.731l4.123 3.555c.464.392.513 1.072.112 1.546l-.006.006z'
          />
        </svg>"
        navigation-prev-label="
        <svg xmlns='http://www.w3.org/2000/svg' width='23' height='23' transform= 'rotate(90)'>
          <path
            fill-rule='evenodd'
            fill='#A4B1C2'
            d='M11.5 22.999c-3.072 0-5.96-1.196-8.132-3.367A11.425 11.425 0 010 11.5c0-3.073 1.196-5.961 3.368-8.133A11.428 11.428 0 0111.5 0c3.073 0 5.961 1.196 8.133 3.367A11.429 11.429 0 0123 11.5c0 6.341-5.159 11.499-11.5 11.499zm0-20.835c-5.147 0-9.335 4.188-9.335 9.336 0 5.147 4.188 9.335 9.335 9.335 5.148 0 9.335-4.188 9.335-9.335 0-5.148-4.187-9.336-9.335-9.336zm0 15.105l-4.124-3.556a1.054 1.054 0 01-.363-.828c0-.271.087-.518.252-.716.206-.244.503-.383.817-.383.261 0 .512.097.705.273l1.631 1.394V7.142A1.07 1.07 0 0111.5 6.06c.607 0 1.083.475 1.083 1.082v6.311l1.633-1.396a1.07 1.07 0 01.699-.261c.304 0 .601.133.814.365l.006.007c.401.474.352 1.153-.112 1.546L11.5 17.269z'
          />
        </svg>"
        ref="carousel"
        :speed="carouselTransitionSpeed"
        @pageChange="pageChange"
        :navigate-to="currentPage"
        v-if="this.$attrs.propOffice === config.rootcategories.biuro"
      >
        <slide
          v-for="(images, index) in gallery"
          :key="images.src"
        >
          <div
            class="product-image-container bg-cl-transparent"
            :class="{'video-container w-100 h-100 flex relative': images.video}"
          >
            <product-image-cloudfront
              v-show="hideImageAtIndex !== index"
              class="product-image pointer"
              :class="{ 'product-image--video': images.video }"
              :thumbnail-path="images.thumbnail_path"
              :thumbnail-size="'410'"
              :alt="productName | htmlDecode"
              @dblclick="openOverlay"
            />
            <product-video
              v-if="images.video && (index === currentPage)"
              v-bind="images.video"
              :index="index"
              @video-started="onVideoStarted"
            />
          </div>
        </slide>
      </carousel>

      <product-image-cloudfront
        v-if="gallery.length == 0"
        class="product-image pointer"
        :thumbnail-path="''"
        :thumbnail-size="'410'"
        :alt="productName | htmlDecode"
      />
      <i
        class="material-icons p15 cl-bgs-tertiary pointer"
        :class="[
          {'zoom-in': this.$attrs.propOffice === config.rootcategories.drukowanie},
          {'zoom-in-office': this.$attrs.propOffice === config.rootcategories.biuro}]"
        @click="openOverlay"
      >zoom_in</i>
    </div>
  </div>
</template>

<script>
import config from 'config'
import ProductImage from './ProductImage'
import ProductImageCloudfront from './ProductImageCloudfront'
import ProductVideo from './ProductVideo'
import Thumbnails from './Thumbnails'
import reduce from 'lodash-es/reduce'
import map from 'lodash-es/map'

export default {
  name: 'ProductGalleryCarousel',
  components: {
    'Carousel': () => import(/* webpackChunkName: "vue-carousel" */ 'vue-carousel').then(Slider => Slider.Carousel),
    'Slide': () => import(/* webpackChunkName: "vue-carousel" */ 'vue-carousel').then(Slider => Slider.Slide),
    ProductImage,
    ProductVideo,
    ProductImageCloudfront,
    Thumbnails
  },
  props: {
    gallery: {
      type: Array,
      required: true
    },
    productName: {
      type: String,
      default: ''
    },
    configuration: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      config,
      carouselTransition: true,
      carouselTransitionSpeed: 0,
      currentColor: 0,
      currentPage: 0,
      hideImageAtIndex: null
    }
  },
  computed: {},
  beforeMount () {
    this.$bus.$on('product-after-configure', this.selectVariant)
    this.$bus.$on('product-after-load', this.selectVariant)
  },
  mounted () {
    this.selectVariant()

    if (this.configuration.color) {
      const { color } = this.configuration
      this.currentColor = color.id
    }

    this.$emit('loaded')
  },
  beforeDestroy () {
    this.$bus.$off('product-after-configure', this.selectVariant)
    this.$bus.$off('product-after-load', this.selectVariant)
  },
  methods: {
    navigate (index) {
      if (index < 0) return
      this.currentPage = index
    },
    async selectVariant (configuration) {
      await this.$nextTick()
      if (config.products.gallery.mergeConfigurableChildren) {
        const option = reduce(map(this.configuration, 'attribute_code'), (result, attribute) => {
          result[attribute] = this.configuration[attribute].id
          return result
        }, {})
        if (option) {
          let index = this.gallery.findIndex(
            obj => obj.id && Object.entries(obj.id).toString() === Object.entries(option).toString(), option)
          if (index < 0) index = this.gallery.findIndex(obj => String(obj.id && obj.id.color) === String(option.color))
          this.navigate(index)
        }
      }

      this.$emit('close')
    },
    openOverlay () {
      const currentSlide = this.$refs.carousel.currentPage
      this.$emit('toggle', currentSlide)
    },
    switchCarouselSpeed () {
      const { color } = this.configuration
      if (color && this.currentColor !== color.id) {
        this.currentColor = color.id
        this.carouselTransitionSpeed = 0
      } else {
        this.carouselTransitionSpeed = 500
      }
    },
    pageChange (index) {
      this.switchCarouselSpeed()
      this.hideImageAtIndex = null
    },
    onVideoStarted (index) {
      this.hideImageAtIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/animations/transitions';
@import '~theme/css/helpers/functions/color';
$color-gainsboro: color(gainsboro);

.media-gallery-carousel {
  position: relative;
  text-align: center;
  height: 100%;

  @media (min-width: 768px) {
    display: flex;
  }

  .thumbnails {
    display: none;
    @media (min-width: 768px) {
      display: block;
      flex: 0 0 100px;
      margin: 0 20px 0 0;
      background: #fff;
      height: 508px;
      overflow: auto;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &__list {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    &__item {
      border: 1px solid $color-gainsboro;
      margin-bottom: 2px;
    }
  }
  .carousel-wrapper {
    @media (min-width: 768px) {
      flex-grow: 1;
      flex-shrink: 0;
      flex-basis: calc(100% - 120px);
      max-width: calc(100% - 120px);
    }
  }
}
.zoom-in {
  position: absolute;
  bottom: 0;
  right: 0;
}

.zoom-in-office {
  height: 30px;
  position: absolute;
  bottom: -14px;
  right: -10px;
  color: gray;
  font-size: 50px;
 @media(min-width: 768px) {
    bottom: 0;
    top: 180px;
    right: -30px;
  }
  @media(min-width: 992px) {
    top: 250px;
  }
  @media(min-width: 1200px) {
    top: unset;
    bottom: 150px
  }
  @media(min-width: 1540px) {
    bottom: 120px;
    right: 30px;
  }
}

.image{
  opacity: 1;
  will-change: opacity;
  transition: .3s opacity $motion-main;
  &:hover{
    opacity: .9;
  }
}
.product-image {
  mix-blend-mode: multiply;
  opacity: 1;
  will-change: transform;
  transition: 0.3s opacity $motion-main;
  &:hover {
    opacity: 0.9;
  }
  &--video {
    padding-bottom: calc(319% / (568 / 100));
  }
}
.video-container {
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.media-gallery-carousel,
.media-zoom-carousel {
  .VueCarousel-pagination {
    position: absolute;
    bottom: 15px;
    @media (max-width: 767px) {
      display: none;
    }
  }
  .VueCarousel-navigation-button {
    margin: 0;
    transform: translateY(-50%) !important;
  }
  .VueCarousel-slide {
    backface-visibility: unset;
  }
  .VueCarousel-navigation {
    opacity: 0;
    &--disabled {
      display: none;
    }
  }
  .VueCarousel-dot {
    padding: 8px !important;
    button {
      border: 2px solid #828282;
    }
  }
  &:hover {
    .VueCarousel-navigation {
      opacity: .9;
    }
    .VueCarousel-navigation-button {
      transition: opacity 3s;
      &:after {
        background-color: transparent;
      }
    }
  }
}
</style>
